<div class="container-fluid glb-popup">
  <h2> {{formTitle}}</h2>
  <p-toast [style]="{marginTop: '80px'}">
  </p-toast>
  <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

  <button mat-icon-button [mat-dialog-close]="true" style="float:right;top:-50px;background-color: transparent;">
    <i class="pi pi-times" aria-hidden="true"></i>
  </button>
  <hr>
    <div [formGroup]="form1" class="forms w-100 d-block">
      <div class="row m-0">

        <div class="col-lg-12">
          @if (formAlert) {
            <div class="w-100 mb-3">
              <div class="w-100"
                style="text-align: center; background-color: yellow;padding:5px;margin-bottom:15px;">
                <p><b>{{formAlert}}</b></p>
              </div>
            </div>
          }
        </div>

        <div class="col-lg-12">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="taskName" id="taskName" type="text" pInputText>
            <label for="taskName">Task Name</label>
            @for (validation of validationMessages.taskName; track validation) {
              <span>
                @if (form1.get('taskName').hasError(validation.type) && (form1.get('taskName').dirty || form1.get('taskName').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <label for="taskDesc"><strong>Task Description :</strong></label>
          <span class="p-float-label w-100 mb-3">
            <!-- <ckeditor [editor]="editor" formControlName="taskDesc" id="taskDesc" (ready)="onReady($event)"></ckeditor> -->
            <editor
              formControlName="taskDesc"
              id="taskDesc"
						[init]="{
							height: 500,
							base_url: '/tinymce',
							suffix: '.min',
							plugins: 'code anchor autolink charmap codesample emoticons image link lists media searchreplace table visualblocks wordcount',
      toolbar: 'undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | link image media table | align lineheight | numlist bullist indent outdent | emoticons charmap | removeformat'}" >
            </editor>
            @for (validation of validationMessages.taskDesc; track validation) {
              <span>
                @if (form1.get('taskDesc').hasError(validation.type) && (form1.get('taskDesc').dirty || form1.get('taskDesc').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label w-100 mb-3">
            <p-dropdown class="w-100" [options]="categories" formControlName="category" optionLabel="name"
            optionValue="value" placeholder="Select Category"></p-dropdown>
            <label for="Select Category">Select Category</label>
            @for (validation of validationMessages.category; track validation) {
              <span>
                @if (form1.get('category').hasError(validation.type) && (form1.get('category').dirty || form1.get('category').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label w-100 mb-3">
            <p-dropdown class="w-100" [options]="statuses" formControlName="status" optionLabel="name"
            optionValue="value" placeholder="Select Status"></p-dropdown>
            <label for="Select Status">Select Status</label>
            @for (validation of validationMessages.status; track validation) {
              <span>
                @if (form1.get('status').hasError(validation.type) && (form1.get('status').dirty || form1.get('status').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label w-100 mb-3">
            <p-dropdown class="w-100" [options]="priorities" formControlName="priority" optionLabel="name"
            optionValue="value" placeholder="Select Priority"></p-dropdown>
            <label for="Select Priority">Select Priority</label>
            @for (validation of validationMessages.priority; track validation) {
              <span>
                @if (form1.get('priority').hasError(validation.type) && (form1.get('priority').dirty || form1.get('priority').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label w-100 mb-3">
            <p-dropdown class="w-100" [options]="employees" formControlName="assignedTo" optionLabel="name"
            optionValue="value" placeholder="Assigned To"></p-dropdown>
            <label for="Assigned To">Assigned To</label>
            @for (validation of validationMessages.assignedTo; track validation) {
              <span>
                @if (form1.get('assignedTo').hasError(validation.type) && (form1.get('assignedTo').dirty || form1.get('assignedTo').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label w-100 mb-3">
            <p-calendar formControlName="assignedDate" inputId="assignedDate" appendTo="body">
            </p-calendar>
            <label for="assignedDate">Assigned Date</label>
            @for (validation of validationMessages.assignedDate; track validation) {
              <span>
                @if (form1.get('assignedDate').hasError(validation.type) && (form1.get('assignedDate').dirty || form1.get('assignedDate').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label w-100 mb-3">
            <p-calendar formControlName="completedDate" inputId="completedDate" appendTo="body">
            </p-calendar>
            <label for="completedDate">Completed Date</label>
            @for (validation of validationMessages.completedDate; track validation) {
              <span>
                @if (form1.get('completedDate').hasError(validation.type) && (form1.get('completedDate').dirty || form1.get('completedDate').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="hours" id="hours" type="number" pInputText>
            <label for="hours">Hours</label>
            @for (validation of validationMessages.hours; track validation) {
              <span>
                @if (form1.get('hours').hasError(validation.type) && (form1.get('hours').dirty || form1.get('hours').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label w-100 mb-3">
            <textarea formControlName="comments" id="comments" [rows]="2" pInputTextarea></textarea>
            <label for="comments">Comments</label>
            @for (validation of validationMessages.comments; track validation) {
              <span>
                @if (form1.get('comments').hasError(validation.type) && (form1.get('comments').dirty || form1.get('comments').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        @if (codeProjectId == null && codeTaskId != null) {
          <div class="col-lg-6">
            <span class="p-float-label required-field w-100 mb-3">
              <p-dropdown [options]="codeProjects" formControlName="codeProjectId" appendTo="body" optionLabel="projectName"
                optionValue="codeProjectId" (onChange)="selectCodeProject()" [filter]="true" filterBy="projectName" [showClear]="false"
                placeholder="Select Code Project" readonly="true">
              </p-dropdown>
              <label for="Select Code Project">Select Code Project</label>
              <span>
                @if (codeProjectIdRequired) {
                  <small class="p-invalid"
                    >Project is required. (If project is not here in dropdown, so please add project first and then add task)
                  </small>
                }
              </span>
            </span>
          </div>
        }

        @if (codeProjectId == null && codeTaskId == null) {
          <div class="col-lg-6">
            <span class="p-float-label required-field w-100 mb-3">
              <p-dropdown [options]="codeProjects" formControlName="codeProjectId" appendTo="body" optionLabel="projectName"
                optionValue="codeProjectId" (onChange)="selectCodeProject()" [filter]="true" filterBy="projectName" [showClear]="false"
                placeholder="Select Code Project">
              </p-dropdown>
              <label for="Select Code Project">Select Code Project</label>
              <span>
                @if (codeProjectIdRequired) {
                  <small class="p-invalid"
                    >Project is required. (If project is not here in dropdown, so please add project first and then add task)
                  </small>
                }
              </span>
            </span>
          </div>
        }
      </div>
    </div>
    <hr>
      <div class="row m-0">
        <div class="col-lg-12">
          <div class="btn-group">
            <div class="button-group">
              @if (codeTaskId) {
                <button pButton class="btn-delete p-button-outlined p-button-danger"
                (click)="onFormDelete()">Delete CodeTask</button>
              }
            </div>

            <div class="button-group">
              <button pButton class="btn-cancel p-button-text" [mat-dialog-close]="true">Cancel</button>
              @if (!codeTaskId) {
                <button pButton class="btn-addt p-button" (click)="formAdd()">Add CodeTask</button>
              }

              @if (codeTaskId) {
                <button pButton  class="btn-upt p-button" (click)="formUpdate()">Update CodeTask</button>
              }
            </div>
          </div>
        </div>
      </div>
    </div>